<template>
  <div class="wrapper-app">
    <!-- Компонент уведомления об обновлениях -->
    <update-notification v-if="isAuthenticated && isUserLoaded" />
    
    <div v-if="isAuthenticated && isUserLoaded" class="wrapper-app__header">
        <Header 
            v-if="!isClientAccount && !isB2CAccount && !isAgentAccount && !isLawyerAccount && !isHrAccount && !isLeadObserverAccount"
            @search="search"
        />
        <HeaderB2C v-else-if="isB2CAccount" />
        <HeaderAgent v-else-if="isAgentAccount" />
        <HeaderLawyer v-else-if="isLawyerAccount" />
        <HeaderHr v-else-if="isHrAccount" />
        <HeaderLeadObserver v-else-if="isLeadObserverAccount" />
        <HeaderClient v-else />
    </div>
    <div class="wrapper-app__row">
      <div
        v-if="isAuthenticated && isUserLoaded"
        class="wrapper-app__sidebar-menu"
      >
        <SidebarMenu v-if="!isClientAccount && !isB2CAccount && !isAgentAccount && !isLawyerAccount && !isHrAccount && !isLeadObserverAccount" />
        <SidebarMenuB2C v-else-if="isB2CAccount" />
        <SidebarMenuAgent v-else-if="isAgentAccount" />
        <SidebarMenuLawyer v-else-if="isLawyerAccount" />
        <SidebarMenuHr v-else-if="isHrAccount" />
        <SidebarMenuLeadObserver v-else-if="isLeadObserverAccount" />
        <SidebarMenuClient v-else />
      </div>
      <div class="wrapper-app__content" :class="{ 'p-0': !isAuthenticated }">
        <template v-if="isAuthenticated && isUserLoaded">
            <router-view 
                :search-result="searchResult" 
                :changed-item="changedItem" 
            />
        </template>
        <template v-else-if="$route.name === 'agentRegister'">
            <AgentRegisterPage />
        </template>
        <template v-else-if="$route.name === 'agentsOferta'">
            <AgentsOfertaPage />
        </template>
        <template v-else-if="$route.name === 'privacyPolicy'">
          <PrivacyPolicyPage />
        </template>
        <template v-else-if="$route.name === 'passwordReset'">
          <PasswordReset />
        </template>
        <template v-else>
            <LoginPage />
        </template>
      </div>
    </div>

    <!-- Global Modals -->
    <FileViewer />
    <PushService />
    <FloatingChat />
    <component
      v-for="(component, index) in computedComponents"
      :key="component"
      :is="component"
      @onSaveChanges="onSaveChanges"
      :width="smallScreen[index]"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Header from "@components/templates/Header.vue";
import HeaderClient from "@components/templates/HeaderClient.vue";
import HeaderB2C from "@components/templates/b2c/HeaderB2C.vue";
import HeaderAgent from "@components/templates/agent/HeaderAgent.vue";
import HeaderLawyer from "@components/templates/lawyer/HeaderLawyer.vue";
import HeaderHr from "@components/templates/hr/HeaderHr.vue";
import HeaderLeadObserver from "@components/templates/lead-observer/HeaderLeadObserver.vue";
import SidebarMenu from "@components/templates/SidebarMenu.vue";
import SidebarMenuClient from "@components/templates/SidebarMenuClient.vue";
import SidebarMenuB2C from "@components/templates/b2c/SidebarMenuB2C.vue";
import SidebarMenuAgent from "@components/templates/agent/SidebarMenuAgent.vue";
import SidebarMenuLawyer from "@components/templates/lawyer/SidebarMenuLawyer.vue";
import SidebarMenuHr from "@components/templates/hr/SidebarMenuHr.vue";
import SidebarMenuLeadObserver from "@components/templates/lead-observer/SidebarMenuLeadObserver.vue";
import LoginPage from "@/views/Login/Login.vue";
import AgentRegisterPage from "@/views/AgentRegister.vue";
import AgentsOfertaPage from "@/views/AgentsOfertaPage.vue";
import PrivacyPolicyPage from "@/views/PrivacyPolicyPage.vue";
import PasswordReset from "@/views/PasswordReset.vue";

import FileViewer from "@components/FileViewer/FileViewer";
import PushService from "@components/notifications/PushService.vue";
import OrderDetailWidget from "@components/orders/detailWidget/OrderDetailWidget";
import OrderDetailWidgetClient from "@components/orders/detailWidget/OrderDetailWidgetClient";
// import OrderDetailWidgetAgent from "@components/orders/detailWidget/OrderDetailWidgetAgent";
import CompanyDetailWidget from "@components/companies/detailWidget/CompanyDetailWidget";
import FinanceDetailWidget from "@components/finance/detailWidget/FinanceDetailWidget";
import FinanceDetailWidgetClient from "@components/finance/detailWidget/FinanceDetailWidgetClient";
import TaskDetailWidget from "@components/task/detailWidget/TaskDetailWidget";
import EmailTrackingDetailWidget from "@/components/emailTracking/EmailTrackingDetailWidget";
import FloatingChat from "@/components/chats/FloatingChat";

export default {
  name: "App",

  components: {
    Header,
    HeaderClient,
    HeaderB2C,
    HeaderAgent,
    HeaderLawyer,
    HeaderHr,
    HeaderLeadObserver,
    SidebarMenu,
    SidebarMenuClient,
    SidebarMenuB2C,
    SidebarMenuAgent,
    SidebarMenuLawyer,
    SidebarMenuHr,
    SidebarMenuLeadObserver,
    LoginPage,
    AgentRegisterPage,
    AgentsOfertaPage,
    PrivacyPolicyPage,
    PasswordReset,
    FileViewer,
    PushService,
    OrderDetailWidget,
    OrderDetailWidgetClient,
    // OrderDetailWidgetAgent,
    CompanyDetailWidget,
    FinanceDetailWidget,
    FinanceDetailWidgetClient,
    TaskDetailWidget,
    EmailTrackingDetailWidget,
    FloatingChat
  },

  metaInfo() {
    return {
      title: this.$route.meta.title,
    };
  },

  data() {
    return {
      width: ['95%', '90%', '85%', '80%'],
      searchResult: '',
      changedItem: {},
      isLoaded: false,
    }
  },

  watch: {
    app_focus: {
      handler(val) {
        const favicon = document.getElementById("favicon");
        if (val) {
          favicon.href = "favicon-main.svg";
        }
      },
      immediate: true,
    },

    isAuthenticated: {
      immediate: true,
      handler(value) {
        if (value) {
          Promise.all([
            this.USER_REQUEST(),
            this.GET_REFERENCE_PROPERTIES(),
            this.GET_GROUPED_REFERENCE_PROPERTIES(),
            this.GET_ALL_USER_LIST(),
            this.GET_ALL_TRANSPORT_LIST(),
          ]).then(() => {
            this.isLoaded = true;
          });
        }
      },
    },
  },

  computed: {
    ...mapGetters("auth", ["isUserLoaded", "isAuthenticated", "currentUser"]),
    ...mapGetters("settings", ["app_focus"]),

    smallScreen() {
      return (this.$mq === 'sm' || this.$mq === 'md') ? ['100%', '100%', '100%', '100%'] : this.width;
    },

    isClientAccount() {
      return this.currentUser.role.includes('client');
    },    

    isAgentAccount() {
      return this.currentUser.role.includes('agent');
    },    
    
    isB2CAccount() {
      return this.currentUser.role.includes('b2c-head-manager') || 
             this.currentUser.role.includes('b2c-manager');
    },
    
    isLawyerAccount() {
        return this.currentUser.role.includes('lawyer-head-manager') || 
             this.currentUser.role.includes('lawyer-manager');
    }, 
    
    isHrAccount() {
        return this.currentUser.role.includes('hr-head-manager') || 
             this.currentUser.role.includes('hr-manager');
    },

    isLeadObserverAccount() {
        return this.currentUser.role.includes('lead-observer');
    }, 

    computedComponents() {
      const arr = Object.keys(this.$route.query);
      let copyOfQuery = arr.slice();
      copyOfQuery = copyOfQuery.filter(el => el === 'company' || el === 'order' || el === 'finance' || el === 'task' || el === 'email-tracking');
      copyOfQuery = copyOfQuery.map(el => {
        if (this.isClientAccount) {
          el = el + '-detail-widget-client'
        } else if (this.isAgentAccount) {
          // el = el + '-detail-widget-agent'
          el = el + '-detail-widget'
        } else {
          el = el + '-detail-widget'
        }
        return el
      });
      return copyOfQuery;
    },
  },

  methods: {
    ...mapActions("auth", ["USER_REQUEST"]),
    ...mapActions("settings", ["changeFocusApp"]),
    ...mapActions({
      GET_REFERENCE_PROPERTIES: "GET_REFERENCE_PROPERTIES",
      GET_GROUPED_REFERENCE_PROPERTIES: "GET_GROUPED_REFERENCE_PROPERTIES",
      GET_ALL_USER_LIST: "GET_ALL_USER_LIST",
      GET_ALL_TRANSPORT_LIST: "GET_ALL_TRANSPORT_LIST",
    }),

    checkQueryForOpenSidebar(querys) {
      querys.forEach(query => {
        this.$root.$emit('bv::toggle::collapse', `sidebar-right-${query}`);
      })
    },
    search(e) {
      this.searchResult = e;
    },
    onSaveChanges(changedItem) {
      this.changedItem = changedItem;
    }
  },

  mounted() {
    this.changeFocusApp();
    if (Object.keys(this.$route.query).length) {
      this.checkQueryForOpenSidebar(Object.keys(this.$route.query));
    }
  }
};
</script>

<style lang="scss" src="~/components/app/app.scss" />
